import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken } from 'firebase/messaging';

// আপনার ফায়ারবেইজ প্রজেক্ট কনফিগারেশন
const firebaseConfig = {
  apiKey: "AIzaSyDrAusYTVWCsKFzInOJTf0mmDxMarcoBgo",
  authDomain: "nexora-20b02.firebaseapp.com",
  projectId: "nexora-20b02",
  storageBucket: "nexora-20b02.firebasestorage.app",
  messagingSenderId: "864705950502",
  appId: "1:864705950502:web:9382abfc3ebe06ef6b07e7",
  measurementId: "G-203FDJWEPP"
};

// ফায়ারবেইজ ইনিশিয়ালাইজেশন
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

const supportsMessaging = typeof window !== 'undefined'
  && 'serviceWorker' in navigator
  && 'Notification' in window
  && 'PushManager' in window
  && (window.location.protocol === 'https:'
    || window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1');

export const messaging = supportsMessaging ? getMessaging(app) : null;

export const getFcmToken = async (registration) => {
  if (!messaging) {
    console.warn('FCM unsupported in this browser or insecure context.');
    return null;
  }

  try {
    const options = registration ? { serviceWorkerRegistration: registration } : {};
    const token = await getToken(messaging, options);
    return token;
  } catch (error) {
    console.error('FCM getToken error:', error);
    return null;
  }
};

export default app;